const e = {
  "skeleton-container": "_skeleton-container_j2tdl_1"
};
export {
  e as default
};
//# sourceMappingURL=index.es748.js.map
